var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext, useContext } from 'react';
import ContentfulLoadError from '../../errors/ContentfulLoadError';
import { useMastheadData } from '../../utils/contentful';
export var FrodorContentfulEntryId = '6ACS5TMQXyfAbP7Uxx5GrZ';
export var DefaultInteractiveElement = function (_a) {
    var customComponent = _a.customComponent, children = _a.children, props = __rest(_a, ["customComponent", "children"]);
    var defaultComponent = props.href ? 'a' : 'button';
    var Component = customComponent || defaultComponent;
    return (React.createElement(Component, __assign({}, props, { onClick: function () {
            var _a;
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props);
        } }), children));
};
var contextDefaults = {
    clientId: '',
    mastheadData: null,
    language: {
        locale: 'en-US',
        dir: 'ltr',
        onClick: function () { }
    },
    getLoginRedirectUri: function () { return 'https://artists.spotify.com/c'; },
    InteractiveElement: DefaultInteractiveElement
};
var S4AMastheadContext = createContext(contextDefaults);
export var useS4AMastheadContext = function () {
    return useContext(S4AMastheadContext);
};
export var S4AMastheadProvider = function (_a) {
    var children = _a.children, _b = _a.clientId, clientId = _b === void 0 ? contextDefaults.clientId : _b, _c = _a.getLoginRedirectUri, getLoginRedirectUri = _c === void 0 ? contextDefaults.getLoginRedirectUri : _c, language = _a.language, _d = _a.contentfulEntryId, contentfulEntryId = _d === void 0 ? FrodorContentfulEntryId : _d, _e = _a.InteractiveElement, InteractiveElement = _e === void 0 ? contextDefaults.InteractiveElement : _e;
    var _f = useMastheadData(language.locale, contentfulEntryId), mastheadData = _f.data, error = _f.error;
    if (error) {
        throw new ContentfulLoadError(error);
    }
    return (React.createElement(S4AMastheadContext.Provider, { value: {
            clientId: clientId,
            mastheadData: mastheadData,
            language: language,
            getLoginRedirectUri: getLoginRedirectUri,
            InteractiveElement: InteractiveElement
        } }, children));
};
